/**
 * Card Link
 */

import React from 'react';
import clsx from 'clsx';

import Link from 'components/Link';
import Icon from 'components/Icon';
import { IImage } from 'types/global';

export interface LinkProps {
	/** Card Link heading */
	heading: string;

	/** Card Link image */
	image?: IImage;

	/** Card Link url */
	url: string;

	id: number | string;

	/**we wont use this body in this component- will remove it later */
	body?: string;

	/** Link size (size changes for text/image) */
	size?: 'small' | 'large';
}

/** Tiny image links block used by Legend */
const CardLink: React.FC<LinkProps> = ({
	heading,
	image,
	url,
	size = 'small',
	id,
}) => (
	<Link
		href={url}
		className={clsx(
			'shadow-card flex flex-wrap items-center rounded-lg bg-white no-underline hover:shadow-md group',
			size === 'small' ? 'md:h-card mb-4' : 'h-24 mb-2'
		)}
	>
		<div
			className={clsx(
				'bg-grey-light  rounded-bl-lg rounded-tl-lg',
				size === 'small' ? 'w-20 h-card' : 'w-20 lg:w-32 h-24'
			)}
		>
			<img
				src={image?.src}
				alt={''}
				className="w-full h-full object-cover  rounded-bl-lg rounded-tl-lg"
			/>
		</div>

		<div className="flex justify-between flex-1 items-center ml-3">
			<h3
				id={`link-with-image-block-title-${id}`}
				className={clsx(
					'no-underline font-bold font-standard group-hover:underline',
					size === 'large'
						? 'text-base lg:text-h4 px-4 leading-6'
						: 'text-base leading-5'
				)}
			>
				{heading}
			</h3>

			<Icon size={1} icon="chevron" direction="left" className="mr-5" />
		</div>
	</Link>
);

export default CardLink;
